const PENDING_REFERRAL_UPGRADE_CHECKOUT_STORAGE_KEY = 'bustly_pending_referral_upgrade_checkout';

export interface PendingReferralUpgradeCheckout {
    sessionId: string;
    workspaceId: string;
}

const storage = (): Storage | null => {
    try {
        return typeof window === 'undefined' ? null : window.sessionStorage;
    } catch {
        return null;
    }
};

export const writePendingReferralUpgradeCheckout = (pending: PendingReferralUpgradeCheckout): void => {
    if (!pending.sessionId.trim() || !pending.workspaceId.trim()) return;
    try {
        storage()?.setItem(PENDING_REFERRAL_UPGRADE_CHECKOUT_STORAGE_KEY, JSON.stringify({
            sessionId: pending.sessionId.trim(),
            workspaceId: pending.workspaceId.trim(),
        }));
    } catch {
        // The existing Stripe expiry/webhook path remains the fallback when browser storage is unavailable.
    }
};

export const readPendingReferralUpgradeCheckout = (): PendingReferralUpgradeCheckout | null => {
    try {
        const value = storage()?.getItem(PENDING_REFERRAL_UPGRADE_CHECKOUT_STORAGE_KEY);
        if (!value) return null;
        const parsed = JSON.parse(value) as Partial<PendingReferralUpgradeCheckout>;
        return typeof parsed.sessionId === 'string' && parsed.sessionId.trim()
            && typeof parsed.workspaceId === 'string' && parsed.workspaceId.trim()
            ? { sessionId: parsed.sessionId.trim(), workspaceId: parsed.workspaceId.trim() }
            : null;
    } catch {
        return null;
    }
};

export const clearPendingReferralUpgradeCheckout = (): void => {
    try {
        storage()?.removeItem(PENDING_REFERRAL_UPGRADE_CHECKOUT_STORAGE_KEY);
    } catch {
        // Nothing to clear when browser storage is unavailable.
    }
};
